import React, { Component } from 'react';
import CheckDefecto from "../../../Common/Components/CheckDefecto";

class CargoCajeros extends Component {
    constructor(props){
        super(props)
        this.state={
            cargaDefault:false
        }
    }
    render() {
 const {cargo,data,selectCheckBox,tarjetas}=this.props

 if(data.idAdicional == 0 && tarjetas.esCuentaExistente && Array.isArray(data.cuentasAdicionales) && data.cuentasAdicionales.length>0 && this.state.cargaDefault == false){
    let idMayor = 0;
    let conCargo= false;
    data.cuentasAdicionales.map(cuenta=>{if(cuenta.Id>idMayor && cuenta.SolicitudId){idMayor = cuenta.Id ; conCargo = cuenta.CargoUsoCajeros == "CC"} });
    if(conCargo) selectCheckBox("usoCajerosConCargo", true);
    this.setState({cargaDefault:true});
 }

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <label className="label-primary">{"Cargo cajero para esta tarjeta"}</label>
                    <div className="row">
                        <div className="col-xs-12">
                        {tarjetas.esCuentaExistente ? <CheckDefecto
                                nombre={"Con Cargo por Uso de Cajero"}
                                check={data.usoCajerosConCargo}
                                referencia={"usoCajerosConCargo"}
                                selectCheckBox={(event) => selectCheckBox("usoCajerosConCargo", event.target.checked)}
                            />:
                        <label className="label-secondary">{cargo == "SC" ? "Uso de cajeros sin cargo para esta tarjeta":"Uso de cajeros con cargo para esta tarjeta"}</label>}
                        
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

export default CargoCajeros;